import { Badge } from '@libs/ui/ds'
import moment from 'moment'
import React from 'react'
import type { FC } from 'react'

import { publicHolidaysSelectors } from '../../redux/selectors'

type Props = {
  date: string
  className?: string
}
const PublicHolidayBadge: FC<Props> = ({ date, className = undefined }) => {
  const dateISO = moment(date).format('YYYY-MM-DD')
  const publicHolidays = publicHolidaysSelectors.useGetCachedMap()

  if (!publicHolidays?.[dateISO]) {
    return null
  }

  return (
    <div className={className}>
      <Badge
        color='semantic.blue'
        label={publicHolidays[dateISO].name}
        size='xs'
      />
    </div>
  )
}

export default PublicHolidayBadge
